/* Maison Carthia — Where to Find Us
   Client-side "nearest to me" ranking. No API key, no network calls.
   Uses the browser Geolocation API + Haversine distance against each
   location card's data-lat / data-lng. Degrades silently when geolocation
   is unavailable, denied, or the coordinates are missing. */
(function () {
  'use strict';

  var EARTH_RADIUS_KM = 6371;

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(km) {
    if (km < 1) {
      return Math.round(km * 1000) + ' m away';
    }
    if (km < 10) {
      return km.toFixed(1) + ' km away';
    }
    return Math.round(km) + ' km away';
  }

  function rankSection(root) {
    var btn = root.querySelector('[data-mc-locate]');
    var grid = root.querySelector('[data-mc-grid]');
    var note = root.querySelector('[data-mc-locate-note]');
    if (!btn || !grid) return;

    if (!('geolocation' in navigator)) {
      btn.style.display = 'none';
      return;
    }

    btn.addEventListener('click', function () {
      btn.setAttribute('aria-busy', 'true');
      if (note) note.textContent = '';

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          btn.removeAttribute('aria-busy');
          applyRanking(grid, pos.coords.latitude, pos.coords.longitude, note);
        },
        function (err) {
          btn.removeAttribute('aria-busy');
          if (note) {
            note.textContent =
              err && err.code === err.PERMISSION_DENIED
                ? 'Location access was blocked. Showing all locations.'
                : 'Could not determine your location. Showing all locations.';
          }
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    });
  }

  function applyRanking(grid, userLat, userLng, note) {
    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('[data-mc-card]')
    );

    var withCoords = [];
    cards.forEach(function (card) {
      card.classList.remove('is-nearest');
      var banner = card.querySelector('[data-mc-nearest-banner]');
      if (banner) banner.hidden = true;
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      var slot = card.querySelector('[data-mc-distance]');

      if (isNaN(lat) || isNaN(lng)) {
        if (slot) {
          slot.textContent = '';
          slot.hidden = true;
        }
        card.dataset.mcDistance = '';
        return;
      }

      var km = haversineKm(userLat, userLng, lat, lng);
      card.dataset.mcDistance = String(km);
      if (slot) {
        slot.textContent = formatDistance(km);
        slot.hidden = false;
      }
      withCoords.push({ card: card, km: km });
    });

    if (!withCoords.length) {
      if (note) {
        note.textContent =
          'Distances are unavailable for these locations right now.';
      }
      return;
    }

    // Sort cards with coordinates by distance; cards without coordinates
    // keep their original order and sit after the ranked ones.
    withCoords.sort(function (a, b) {
      return a.km - b.km;
    });

    withCoords.forEach(function (entry) {
      grid.appendChild(entry.card);
    });
    cards.forEach(function (card) {
      if (!card.dataset.mcDistance) grid.appendChild(card);
    });

    var nearestCard = withCoords[0].card;
    nearestCard.classList.add('is-nearest');
    var nearestBanner = nearestCard.querySelector('[data-mc-nearest-banner]');
    if (nearestBanner) nearestBanner.hidden = false;

    if (note) {
      note.textContent =
        'Sorted by distance — your nearest location is highlighted.';
    }

    // Draw the eye to the highlighted nearest card.
    if (withCoords.length > 1 && typeof nearestCard.scrollIntoView === 'function') {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      nearestCard.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-mc-find-us]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.mcInit === 'true') return;
      root.dataset.mcInit = 'true';
      rankSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
